var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6956 0.99981L32.9999 10.8515V29.1477L17.6956 38.9997L0.999936 29.1126V10.8571L17.6956 0.99981Z",
    fill: "#FEFEFE",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 0.579385L17.7069 0.412472L17.4413 0.569253L0.74573 10.4265L0.499936 10.5716V10.8571V29.1126V29.3976L0.745162 29.5429L17.4408 39.4299L17.7065 39.5872L17.9662 39.4201L33.2705 29.5682L33.4999 29.4205V29.1477V10.8515V10.5787L33.2705 10.431L17.9662 0.579385Z",
    stroke: "#FEFEFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61095 18.4098C9.61095 18.4098 10.7777 17.1153 11.2222 17.9974C11.6668 18.8797 12.3889 20.2326 13.4444 25.1733C13.6328 26.0866 14.1359 27.0717 15.3331 26.9967C16.7361 26.9083 22.4661 22.851 22.9998 16.8214C22.9998 16.1156 22.9384 14.1462 20.6665 13.9983C19.6112 14.1159 18.1111 14.3509 16.9445 17.4682C17.7776 17.1742 19.2777 16.9977 18.8887 18.5855C18.5 19.8797 16.3193 23.8642 15.8612 21.3062C15.5833 19.4828 14.8331 16.1156 14.8331 16.1156C14.8331 16.1156 14.6663 13.7622 12.9998 14.2919C11.9999 14.8214 8.99987 17.4682 8.99987 17.4682L9.61095 18.4098Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_285",
    x: 0,
    y: -0.174805,
    width: 35.9998,
    height: 43.8496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_285",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.ff9661907c7c9ff196573e00a1458d7c.svg";
export { ForwardRef as ReactComponent };